module.exports = __webpack_public_path__ + "media/images/success/hint_icon-7e93722cd56f9820ac15989c95f20113.png";